import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';

export default function MqttConfirmModal({ show, onHide, onConfirm }) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      backdrop="static"
      keyboard={false}
      scrollable
      centered
      className="cs-diagnostics-mqtt-modal"
    >
      <Modal.Header closeButton className="text-white border-0">
        <Modal.Title>Fetch Data From Charging Station</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="h6 text-center my-3 opacity-75 fw-normal">
          Fetching data may take up to <span className="fw-bold"> 30 seconds</span>.
        </p>
        <p className="h4 text-center my-3 opacity-75">Do you want to proceed?</p>
        <p className="text-center mt-3 opacity-75" style={{ fontSize: '90px' }}>
          <FontAwesomeIcon icon={faExclamationCircle} className="text-warning" />
        </p>
      </Modal.Body>
      <Modal.Footer className="border-0 pt-0">
        <button
          type="button"
          className="btn btn-sm rounded-5 btn-outline-secondary"
          style={{ width: '80px', fontSize: '16px' }}
          onClick={onHide}
        >
          Cancel
        </button>
        <button type="button" className="btn btn-sm add-button" style={{ width: '80px', fontSize: '16px' }} onClick={onConfirm}>
          Yes
        </button>
      </Modal.Footer>
    </Modal>
  );
}
